import { css } from 'styled-components';
import { FONT_TYPE, FONT_COLOR, FONT_WEIGHT } from './constants'

export type TTypography =
  'display1'
  | 'display2'
  | 'display3'
  | 'heading1'
  | 'heading2'
  | 'heading3'
  | 'heading4'
  | 'heading5'
  | 'subtitle1'
  | 'subtitle1Bold'
  | 'subtitle2'
  | 'body1'
  | 'body1Bold'
  | 'body1XL'
  | 'body1XLBold'
  | 'body2'
  | 'body2Bold'
  | 'body3'
  | 'body3Bold'
  | 'button'
  | 'buttonSmall'
  | 'caption1'
  | 'caption1Bold'
  | 'caption2'
  | 'caption2Bold'
  | 'overline'
  | 'darkLink';

const typographyStyles = {
  display1: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 72px;
    line-height: 96px;
    letter-spacing: -0.02em;
    color: ${FONT_COLOR};
  `,

  display2: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-style: normal;
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 64px;
    line-height: 80px;
    color: ${FONT_COLOR};
  `,

  display3: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 48px;
    line-height: 56px;
    letter-spacing: -0.02em;
    color: ${FONT_COLOR};
  `,

  heading1: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 36px;
    line-height: 48px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  heading2: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 32px;
    line-height: 40px;
    letter-spacing: -0.02em;
    color: ${FONT_COLOR};
  `,

  heading3: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-style: normal;
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.02em;
    color: ${FONT_COLOR};
  `,

  heading4: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 21px;
    line-height: 28px;
    letter-spacing: -0.02em;
    color: ${FONT_COLOR};
  `,

  heading5: css`
    font-family: ${FONT_TYPE.DEMIBOLD};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 18px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  subtitle1: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  subtitle1Bold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  subtitle2: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 14px;
    line-height: 16px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body1: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body1Bold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body1XL: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body1XLBold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body2: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body2Bold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR}
  `,

  body3: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  body3Bold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  button: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 18px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  buttonSmall: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  caption1: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  caption1Bold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  caption2: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 11px;
    line-height: 16px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  caption2Bold: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 11px;
    line-height: 16px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,

  overline: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.015em;
    color: ${FONT_COLOR};
  `,

  overlineBold: css`
    font-family: ${FONT_TYPE.LIGHT};
    font-weight: ${FONT_WEIGHT.DEFAULT};
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.015em;
    color: ${FONT_COLOR};
  `,

  darkLink: css`
    font-family: ${FONT_TYPE.MEDIUM};
    font-weight: ${FONT_WEIGHT.BOLD};
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.01em;
    color: ${FONT_COLOR};
  `,
};

export default typographyStyles;
